module.exports = __webpack_public_path__ + "img/tutor1.a2d89dfe.png";